import { useMemo } from 'react'

import { deriveCatalogCapabilities } from '../utils/deriveCatalogCapabilities'

/**
 * React hook wrapper — memoizes `deriveCatalogCapabilities` over config and settings references.
 *
 * @param {Object}      params
 * @param {object|null} params.appCapabilities    
 * @param {object}      params.fullFiltersRange
 * @param {object|null} params.products          - Full catalog products for dataset capability checks
 * @param {object|null} params.projectConfig     - Configuration object from panel-config.json
 * @param {object|null} params.panelSettings     - Configuration object from panel-settings.json
 * @returns {ReturnType<typeof deriveCatalogCapabilities>} Memoized catalog capabilities object
 */
export function useCatalogCapabilities({
  appCapabilities, 
  fullFiltersRange,
  products,
  projectConfig, 
  panelSettings, 
}) {
  return useMemo(
    () => deriveCatalogCapabilities({
      appCapabilities,
      fullFiltersRange,
      products,
      projectConfig, 
      panelSettings, 
    }), 
    [
      appCapabilities,
      fullFiltersRange,
      products,
      projectConfig, 
      panelSettings, 
    ]
  )
}